import { useState, useEffect } from 'react';
import { GyldendalLogoSmall } from '@ui/kit/icons';
import { configRefs } from '@utils/config';
import { CSSRefTransition } from '@utils/react';
import { modalCls, iframeCls, throbberTransitionDurationMs, throbberCls } from './preview-lightbox.style.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';

function makePreviewLightboxConfig(props) {
  return {
    className: modalCls,
    includeSpeechButton: false,
    content: /*#__PURE__*/jsx(PreviewLightbox, {
      course: props.course
    })
  };
}
function PreviewLightbox(props) {
  const isLoading = useLoadingState(props.course);
  const url = `${configRefs.urls.courses.dangerouslyAssertSyncValue()}/viser/${props.course?.id}`;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("iframe", {
      className: iframeCls,
      src: url,
      title: `Preview af forløbet ${props.course.title}`
    }), /*#__PURE__*/jsx(CSSRefTransition, {
      in: isLoading,
      unmountOnExit: true,
      timeout: throbberTransitionDurationMs,
      children: ref => /*#__PURE__*/jsx("div", {
        ref: ref,
        className: throbberCls,
        children: /*#__PURE__*/jsx(GyldendalLogoSmall, {
          height: 120,
          disableDefaultClassName: true
        })
      })
    })]
  });
}
function useLoadingState(course) {
  const [isLoading, setLoading] = useState(true);
  useEffect(() => {
    if (!course) {
      // bail out if there is no longer any courses to display
      return;
    }

    // register that we've begun a new viewer whenever course model changes, and
    // subscribe to the course-builder:ready event to recieve a callback to know
    // when it's ready for display
    setLoading(true);
    const handleMessage = evt => {
      if (evt.data === "course-viewer:ready") {
        setLoading(false);
      }
    };

    // give up waiting after 6 seconds, so we don't end up showing a
    // throbber forever in case of errors
    const timeout = window.setTimeout(() => {
      setLoading(false);
    }, 6_000);
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
      window.clearTimeout(timeout);
    };
  }, [course]);
  return isLoading;
}

export { PreviewLightbox, makePreviewLightboxConfig };
//# sourceMappingURL=preview-lightbox.js.map
